import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import LineSeparator from "commons/ui/LineSeparator";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import AttachmentPicker from "components/ui/AttachmentPicker";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionOne from "hooks/form/blocks/useSectionOne";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { DesktopOrMobile } from "types/enums";

function SectionOneForm() {
    const { setMainImage, setBackgroundImage, buttonDelete, formHook } = useSectionOne();

    useCheckSectionErrors({ formHook });

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <GridRow>
                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Immagine Principale</h3>
                                    </GridItem>
                                </GridRow>

                                <ExtensionsProporsionInfo
                                    desktopText={"1500x844px (max 400KB)"}
                                    mobileText={"1200x 675px (max 250KB)"}
                                    proportion={"16:9"}
                                />

                                <GridRow>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setMainImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.main_img.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("main_img.desktop")}
                                        />
                                    </GridItem>

                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setMainImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.main_img.mobile}
                                            errors={checkErrorVisibility("main_img.mobile")}
                                            accept={".png,.jpg,.jpeg"}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem className={"col-xs-24-12"}>
                                        <h3>Immagine di Background</h3>
                                    </GridItem>
                                </GridRow>

                                <ExtensionsProporsionInfo
                                    desktopText={"1500x894px (max 200KB)"}
                                    mobileText={"1000 596px (max 100KB)"}
                                    proportion={"16:9"}
                                />

                                <GridRow>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setBackgroundImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.background_img.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("background_img.desktop")}
                                        />
                                    </GridItem>

                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setBackgroundImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.background_img.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("background_img.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>

                    <LineSeparator />

                    <GridColumn>
                        <GridRow>
                            <GridItem className="col-xs-12-12">
                                <h3>Testi</h3>
                            </GridItem>
                        </GridRow>

                        <GridRow>
                            <GridItem>
                                <span>Inserisci i testi per tutte le lingue</span>
                            </GridItem>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-24-12"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            label={"Titolo"}
                                            value={form.text?.it?.title}
                                            setValue={setValue}
                                            path={"text.it.title"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            label={"Sottotitolo"}
                                            value={form.text?.it?.subtitle}
                                            setValue={setValue}
                                            path={"text.it.subtitle"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            label={"Descrizione"}
                                            value={form.text?.it?.description}
                                            setValue={setValue}
                                            path={"text.it.description"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-24-12"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            label={"Titolo"}
                                            value={form.text?.en?.title}
                                            setValue={setValue}
                                            path={"text.en.title"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            label={"Sottotitolo"}
                                            value={form.text?.en?.subtitle}
                                            setValue={setValue}
                                            path={"text.en.subtitle"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            label={"Descrizione"}
                                            value={form.text?.en?.description}
                                            setValue={setValue}
                                            path={"text.en.description"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionOneForm;
